const colorPalette = ["red", "orange", "yellow", "green", "teal", "blue", "cyan", "purple", "pink"];

export const pickPalette = (name) => {
  if (!name) return colorPalette[0]; // Default to first color

  const index = name.charCodeAt(0) % colorPalette.length;
  return colorPalette[index];
};
